import { render, staticRenderFns } from "./OneWishlistProductRowMobileTile.vue?vue&type=template&id=52ac5046&scoped=true&"
import script from "./OneWishlistProductRowMobileTile.vue?vue&type=script&lang=ts&"
export * from "./OneWishlistProductRowMobileTile.vue?vue&type=script&lang=ts&"
import style0 from "./OneWishlistProductRowMobileTile.vue?vue&type=style&index=0&id=52ac5046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac5046",
  null
  
)

export default component.exports